import { userRoleNames } from '@/util/Util'

/**
 * Papéis que não têm tela no backoffice e por isso não votam na visibilidade.
 *
 * `student` é o caso real: todo mundo que compra na plataforma o carrega, e
 * quem já era aluno e vira parceiro passa a ter `student` + `professional`
 * (ou `establishment`). Como a regra abaixo exige exclusividade, esse aluno
 * "extra" fazia o menu do outro papel reaparecer — o parceiro que veio de uma
 * conta de aluno via o menu do papel oposto. Ignorar aqui é preciso: `student`
 * não esconde nem revela nada no backoffice, ele só existe no marketplace.
 */
const NAO_DECIDEM_MENU = ['student']

/**
 * Item de menu visível para os papéis do usuário logado.
 *
 * Complementa o `v-permission` dos componentes de navegação, que só conhece
 * permissão. Item com `hideForRoles` some para quem carrega **apenas** os papéis
 * listados — a exigência de exclusividade evita que uma conta acumulando
 * `influencer` + outro papel perca uma tela que o segundo papel justifica.
 *
 * Sem `hideForRoles`, o item aparece: a regra é opt-in.
 */
export const isItemVisibleForRole = item => {
  const hidden = item && item.hideForRoles

  if (!hidden || !hidden.length) return true

  const roles = userRoleNames().filter(role => !NAO_DECIDEM_MENU.includes(role))

  if (!roles.length) return true

  return !roles.every(role => hidden.includes(role))
}

export default isItemVisibleForRole
